import React from "react";
import { Outlet } from "react-router";

const SolutionPagesLayout = () => {
  return <Outlet />;
};

export default SolutionPagesLayout;
